module.exports = __webpack_public_path__ + "img/sip.c6419ce8.png";